import { SvgIcon, SvgIconProps } from '@mui/material';

const WarningIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99967 7.81249V10.7291M4.30623 12.3332C3.62683 13.4817 3.28722 14.0562 3.33797 14.5275C3.38223 14.9385 3.60326 15.3119 3.94583 15.5549C4.33845 15.8333 5.01744 15.8333 6.37532 15.8333H13.624C14.9819 15.8333 15.6608 15.8333 16.0534 15.5549C16.396 15.3119 16.6171 14.9385 16.6614 14.5275C16.7121 14.0562 16.3726 13.4817 15.6932 12.3332L12.0701 6.20818C11.3907 5.05962 11.0509 4.48543 10.6074 4.29271C10.2206 4.1246 9.77855 4.1246 9.39171 4.29271C8.94839 4.48535 8.60875 5.05954 7.92991 6.20715L4.30623 12.3332ZM10.0376 12.9166V12.9896L9.96247 12.9897V12.9166H10.0376Z"
        stroke="#FF7324"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
);

export default WarningIcon;
